import React, { useCallback, useEffect } from "react";
import {useNavigate} from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as AppActions from "../stores/app/actions";
import { CONTINUE_TRANSACTION_STATE } from '../constants/status';
import LoadingSpin from "../components/LoadingSpin";

export const TransactionPage = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const { code, 'merchant-return-url': merchantReturnUrl } = Object.fromEntries(urlSearchParams.entries());
  const dispatch = useDispatch();
  const appStore = useSelector((store) => store, shallowEqual).app;
  const { continueTransaction, redirectUrl } = appStore;
  const navigate = useNavigate();

  const handleOBVFlow = useCallback(
    (status) => {
      switch (status) {
        case CONTINUE_TRANSACTION_STATE.NONE:
          return dispatch(
            AppActions.continueTransaction({ code, merchantReturnUrl }),
          );
        case CONTINUE_TRANSACTION_STATE.GET_LINK_SUCCESS:
          window.location.href = redirectUrl;
          break;
        case CONTINUE_TRANSACTION_STATE.FAILURE:
          return navigate("/transactionError");
        default:
          return true;
      }
    },
    [navigate, dispatch, code, merchantReturnUrl, redirectUrl],
  );

  useEffect(() => {
    handleOBVFlow(continueTransaction);
  }, [continueTransaction, handleOBVFlow]);

  return (
    <div>
      <LoadingSpin />
    </div>
  );
};

TransactionPage.propTypes = {};

TransactionPage.defaultProps = {};

export default TransactionPage;
